import '@fontsource-variable/manrope';
import '@fontsource-variable/noto-sans-arabic';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { i18nReady } from './i18n';
import { installDevelopmentNetworkGuard } from './security/networkGuard';
import './styles/global.css';

installDevelopmentNetworkGuard();

const root = document.getElementById('root');
if (!root) throw new Error('Application root element is missing.');

void i18nReady.then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
